import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { PROFILE } from "../data";

const LINKS = [
  { label: "Work", id: "work" },
  { label: "Expertise", id: "expertise" },
  { label: "Experience", id: "experience" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const scroll = () => {
      const el = document.getElementById(id);
      if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
      else if (el) el.scrollIntoView({ behavior: "smooth" });
    };
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 250);
    } else scroll();
  };

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50"
    >
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 pt-4">
        <div
          className={`flex items-center justify-between rounded-full px-5 md:px-6 h-14 transition-all duration-500 ${
            scrolled ? "bg-card/85 backdrop-blur-md shadow-[0_10px_30px_-18px_rgba(23,23,26,0.4)]" : "bg-transparent"
          }`}
        >
          <button data-testid="nav-logo" onClick={() => go("top")} className="flex items-center gap-2 font-display font-semibold text-lg">
            <span className="w-6 h-6 rounded-md bg-accent inline-flex items-center justify-center text-white text-xs font-bold">J</span>
            Jesal Sharma
          </button>

          <nav className="hidden md:flex items-center gap-1 bg-bg-dark/70 rounded-full p-1">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-${l.id}`}
                onClick={() => go(l.id)}
                className="font-display font-medium text-[15px] text-ink px-4 py-2 rounded-full hover:bg-card hover:shadow-[0_2px_8px_-4px_rgba(23,23,26,0.4)] transition-all duration-300"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <button data-testid="nav-contact" onClick={() => go("contact")} className="btn-dark !py-2.5 !px-5 text-sm">
            Contact me
          </button>
        </div>
      </div>
    </motion.header>
  );
}
